import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import AfterPayMessage from './afterpay-cart-message'
import AffirmMessage from './affirm-cart-message'
import PayPalMessage from './paypal-cart-message'
import KlarnaMessage from '../../../../components/product-view/partials/bnpl-messages/klarna-message'

const BNPLCartMessages = ({basketTotal}) => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {klarna} = commerceAPI || {}
    const {configKlarna} = klarna || {}
    let klarnaEnabled = false
    try {
        if (configKlarna) {
            const jsonConfig = JSON.parse(configKlarna)
            klarnaEnabled = Boolean(
                jsonConfig?.enableCartCallout && jsonConfig?.clientId && jsonConfig?.scriptURL
            )
        }
    } catch (e) {
        console.log(e.message)
    }
    return (
        <Box
            className="bnpl-messages"
            gap="5px"
            display="grid"
            sx={{
                '& > div': {
                    minHeight: '22px'
                },
                '& p': {
                    color: 'black.100',
                    fontSize: '12px',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.06px'
                }
            }}
        >
            <AfterPayMessage price={basketTotal} />
            {klarnaEnabled && (
                <Box>
                    <KlarnaMessage price={basketTotal} page="cart" />
                </Box>
            )}
            <AffirmMessage price={basketTotal} />
            <PayPalMessage price={basketTotal} />
        </Box>
    )
}

BNPLCartMessages.propTypes = {
    basketTotal: PropTypes.any
}

export default BNPLCartMessages
